import {
  COUPON_VALIDATE_REQUEST,
  COUPON_VALIDATE_SUCCESS,
  COUPON_VALIDATE_FAIL,
  COUPON_CLEAR,
} from "../constants/couponConstants";

export const couponValidateReducer = (state = {}, action) => {
  switch (action.type) {
    case COUPON_VALIDATE_REQUEST:
      return { loading: true };
    case COUPON_VALIDATE_SUCCESS:
      return { loading: false, coupon: action.payload };
    case COUPON_VALIDATE_FAIL:
      return { loading: false, error: action.payload };
    case COUPON_CLEAR:
      return {};
    default:
      return state;
  }
};
